import { useState, useEffect, useRef, useCallback } from 'react';
import { useOnClickOutside } from '../../../../../hooks/useOnClickOutside';

export function useRibbonExpansionControls() {
  const [isExpanded, setIsExpanded] = useState(false);
  const ribbonRef = useRef<HTMLDivElement>(null);

  const closeMenu = useCallback(() => {
    setIsExpanded(false);
  }, []);

  const handleClickOutside = useCallback(() => {
    if (isExpanded) {
      closeMenu();
    }
  }, [isExpanded, closeMenu]);

  useOnClickOutside(ribbonRef, handleClickOutside);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isExpanded) {
        closeMenu();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isExpanded, closeMenu]);

  const handleToggleExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  return {
    isExpanded,
    ribbonRef,
    handleToggleExpanded,
  };
}
